import { Component, OnInit } from "@angular/core";
import { CommonService, DashboardService } from "../../../services";
import { appSettings } from "../../../settings";
import { environment } from "../../../../environments/environment";
import { UserPreference } from '../../../models/UserPreference';

@Component({
  selector: 'app-widgetconfig',
  templateUrl: './widgetconfig.component.html',
  styleUrls: ['./widgetconfig.component.scss']
})
export class WidgetconfigComponent implements OnInit {

  loading: boolean = false;
  widgets: Array<any> = [];
  editing = {};
  enableSave: boolean = false;
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  constructor(private _commonService: CommonService,
    private _dashboardService: DashboardService) { }

  ngOnInit() {
    this.getCustWidgets();
  }


  facilityChanged(e){
    console.log('facilityChanged', e);
    this.getCustWidgets();
  }

  getCustWidgets() {
    let userPref: UserPreference;
    userPref = this._commonService.getUserPreference();
    this.loading = true;
    this.widgets = [];
    console.time('getCustomerWidgetTypes');
    this._dashboardService.getCustomerWidgetTypes(userPref.FacilityId, userPref.CustomerId)
      .subscribe(data => {
        console.timeEnd('getCustomerWidgetTypes');
        this.loading = false;
        this.widgets = data;
      },
        err => {
          console.timeEnd('getCustomerWidgetTypes');
          console.log('getCustomerWidgetTypes', err);
          this.loading = false;
        }
      )
  }

  updateValue(event, cell, rowIndex) {
    console.log('inline editing rowIndex', rowIndex);
    let userPref: UserPreference;
    userPref = this._commonService.getUserPreference();
    this.editing[rowIndex + '-' + cell] = false;
    let newValue = event.target.value;
    this.widgets[rowIndex][cell] = newValue;
    this.widgets[rowIndex].IsUpdated = true;

    this.widgets = [...this.widgets];

    let updated = this.widgets.filter(x => x.IsUpdated == true);
    if (updated.length > 0) {
      this.enableSave = true;
    }
    console.log('UPDATED!', this.widgets[rowIndex][cell]);
  }

  save() {
    let userPref: UserPreference;
    userPref = this._commonService.getUserPreference();
    let widgetlist: Array<any> = [];
    let updatedWidgets: Array<any> = this.widgets.filter(x => x.IsUpdated == true);
    updatedWidgets.forEach(item => {
      item.Facility = userPref.FacilityId;
      item.CustomerId = userPref.CustomerId;
      widgetlist.push({
        Facility: item.Facility,
        CustomerId: item.CustomerId,
        WidgetTypeId: item.WidgetTypeId,
        IsEnabled: item.IsEnabled
      });
    });
    this.loading = true;
    console.time('saveCustomerWidgetTypes');
    this._dashboardService.saveCustomerWidgetTypes(widgetlist)
      .subscribe(data => {
        console.timeEnd('saveCustomerWidgetTypes');
        this.loading = false;
        this.enableSave = false;
        this.getCustWidgets();
      },
        err => {
          console.timeEnd('saveCustomerWidgetTypes');
          console.log('saveCustomerWidgetTypes', err);
          this.loading = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/widgetconfig/widgetconfig.component.ts